export default __webpack_public_path__ + "static/media/about-us-section-eight-arrow.add46fe8.svg";